import { WebSocketFactory } from 'global-web-socket-client-js/global-web-socket-client-js-bundle.min.js';
import { Logger } from 'global-logger-services-js/global-logger-services-js-bundle';
import { galateaMessageService } from './Services/galateaMessageService.js';

let webSocketClient = null;
let wsServer = null;
let _port = null;
let _keepAlive = 5000;
let _token = null;
let _secureConnection;
export class SingletonWebSocket {
    static _ip = null;
    static GetToken() {
        return _token;
    }
    static setToken(token) {
        _token = token;
    }
    static setwsServer(server) {
        wsServer = server;
    }
    static setPort(port) {
        _port = port;
    }
    static setKeepAlive(setKeepAlive) {
        _keepAlive = setKeepAlive ? 5000 : 0;
    }
    static connect(secureConnection = false) {
        SingletonWebSocket.validate();
        _secureConnection = secureConnection;
        webSocketClient.connect(secureConnection);
    }
    static validate() {
        if (!webSocketClient) {
            webSocketClient = new WebSocketFactory().buildClient();
            webSocketClient.WSParameter.serverIP = wsServer;
            webSocketClient.WSParameter.port = _port;
            webSocketClient.WSParameter.keepAliveMessage = `{client:"integration", action:"KeepAlive", ip:"${_token}"}`;
            webSocketClient.WSParameter.keepAliveTimeResponse = _keepAlive;
            webSocketClient.WSParameter.keepAliveTimeRequest = 30000;
            webSocketClient.WSParameter.IsReconnected = true;
            webSocketClient.WSParameter.ReconnectionTime = 3000;
            webSocketClient.WSParameter.onMessage = (message) => {
                if (message.data !== "added") {
                    let json = JSON.parse(message.data);
                    galateaMessageService.newMessage(json);
                }
            }

            webSocketClient.WSParameter.onOpen = () => {
                console.info("keepAliveMessage", webSocketClient);
                const message = { client: "integration", action: "firstConnection", ip: _token };
                webSocketClient.send(JSON.stringify(message));

            };
            webSocketClient.WSParameter.onClose = () => {
                console.info("Close Socket");
                if (onAgentStatus) {
                    onAgentStatus({ currentState: "SocketClosed" });
                }
                setTimeout(() => {
                    webSocketClient.connect(_secureConnection);
                }, webSocketClient.WSParameter.ReconnectionTime);
            };
            webSocketClient.WSParameter.onError = (error) => {
                Logger.Error(error);
                if (onAgentStatus) {
                    onAgentStatus({ currentState: "Error" });
                }
                setTimeout(() => {
                    webSocketClient.connect(_secureConnection);
                }, webSocketClient.WSParameter.ReconnectionTime);
                if (_timmerSendUserId) {
                    clearTimeout(_timmerSendUserId);
                }
            };
        }
    }

    static send(message) {
        SingletonWebSocket.validate();
        message.ip = _token;
        webSocketClient.send(JSON.stringify(message));
    }
    static setIPAddress(ipAddress) {
        this._ip = ipAddress;
    }
    static get ipAddress() {
        return this._ip;
    }
    static close() {
        webSocketClient.close();
    }
}


// WEBPACK FOOTER //
// ./src/singletonWebSocket.js